export const SET_ADMIN_TOKEN = 'SET_ADMIN_TOKEN';
export const SET_ADMIN_NAME = 'SET_ADMIN_NAME';
export const ADMIN_LOGOUT = 'ADMIN_LOGOUT';

export const SET_CLIENT_TOKEN = 'SET_CLIENT_TOKEN';
export const SET_CLIENT_NAME = 'SET_CLIENT_NAME';
export const CLIENT_LOGOUT = 'CLIENT_LOGOUT';




// WEBPACK FOOTER //
// ./src/store/mutation-types.js